import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { GetFileById, GetFileObjectById, resetGetFileByIdStatus, resetGetFileObjectByIdStatus } from "../../../objectStorage/slice";
import { DocumentIcon } from "../../../ui/icons/documentIcon";
import { TrashIcon } from "../../../ui/icons/trash";
import { RightBar } from "../../../ui/organisms/rightBar";
import { formatterDate } from "../../../utils";
import { UploadedDocumentRightBarAdd } from "./right";
import { DocumentDelete, GetAllDocuments, resetDeleteDocumentStatus, resetGetAllDocumentsStatus, setDocumentCreationCustomerDataId, setDocumentCreationUserId, setGetAllDocumentsFiltersCustomer } from "./slice";

interface Props {
    selectedCustomer: string
}

export function UploadedDocuments(props: Props) {
    const dispatch = useAppDispatch()
    const documentState = useAppSelector(state => state.document)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [fileName, setFileName] = useState<string | null>(null)

    useEffect(() => {
        dispatch(setDocumentCreationCustomerDataId(props.selectedCustomer))
        dispatch(setGetAllDocumentsFiltersCustomer(props.selectedCustomer))
        dispatch(setDocumentCreationUserId(props.selectedCustomer))
    }, [])

    useEffect(() => {
        if (documentState.getAllDocumentsFilters.customer)
            dispatch(GetAllDocuments(documentState.getAllDocumentsFilters))
    }, [documentState.getAllDocumentsFilters.customer])

    useEffect(() => {
        if (documentState.getAllDocumentsStatus === 'successfully') {
            dispatch(resetGetAllDocumentsStatus())
        }
    }, [documentState.getAllDocumentsStatus])

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully' &&
            objectStorageState.getFileObjectByIdResponse !== undefined
        ) {
            dispatch(resetGetFileObjectByIdStatus())
            const data = objectStorageState.getFileObjectByIdResponse
            setFileName(data.name)
            dispatch(GetFileById(data.id))
        }
    }, [objectStorageState.getFileObjectByIdStatus])

    useEffect(() => {
        if (objectStorageState.getFileByIdStatus === 'successfully') {
            dispatch(resetGetFileByIdStatus())
            const base64Data = objectStorageState.getFileByIdResponse?.base64;
            if (base64Data && base64Data !== '') {
                const byteCharacters = atob(base64Data);
                const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));
                const blob = new Blob([byteNumbers], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                // Apri una finestra popup con un titolo personalizzato
                const newWindow = window.open('', '_blank', 'width=800,height=600');
                if (newWindow) {
                    newWindow.document.title = fileName!;
                    const iframe = newWindow.document.createElement('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.src = url;
                    newWindow.document.body.appendChild(iframe);
                }
            }
        }
    }, [objectStorageState.getFileByIdStatus]);

    useEffect(() => {
        if (documentState.documentDeleteStatus === 'successfully') {
            dispatch(resetDeleteDocumentStatus())
            dispatch(GetAllDocuments(documentState.getAllDocumentsFilters))
        }
    }, [documentState.documentDeleteStatus])

    return (
        <div className="flex h-full bg-brandPrimary-100">
            <div className="flex-[0.7] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-brandPrimary-200 border-r border-neutral-200 p-6 rounded-tr-xl">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm bg-white">
                    <table id="users-table" className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tl-xl w-[70px]">Elimina</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Dettaglio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegato</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Oggetto</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Utente</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[70px]">File</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(documentState.getAllDocumentsResponse?.data ?? []).length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                        Nessun documento trovato
                                    </td>
                                </tr>
                            ) : (
                                (documentState.getAllDocumentsResponse?.data ?? []).map((doc, index) =>
                                    <tr
                                        key={index}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 w-[70px]">
                                            <div className="flex justify-center items-center">
                                                <button className="cursor-pointer" onClick={() => {
                                                    dispatch(DocumentDelete(doc.id))
                                                }}>
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(doc.date)}</td>
                                        <td className="px-3 py-2 text-neutral-700">{doc.detail || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{doc.entryAttachment ? `${doc.entryAttachment.description} [${doc.entryAttachment.coding}]` : '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{doc.entryObject ? `${doc.entryObject.description} [${doc.entryObject.coding}]` : '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{doc.user ? `${doc.user.name} ${doc.user.surname}` : '-'}</td>
                                        <td className="px-3 py-2 w-[70px]">
                                            <div className="flex justify-center items-center">
                                                <button className="cursor-pointer" onClick={() => {
                                                    dispatch(GetFileObjectById(String(doc.fileId)))
                                                }}>
                                                    <DocumentIcon />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex-[0.3] overflow-y-auto bg-white">
                <RightBar>
                    <UploadedDocumentRightBarAdd />
                </RightBar>
            </div>
        </div>
    )
}